import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const CustomSelect = ({
  options,
  value,
  onChange,
  placeholder = "Select...",
  className = "",
  isCreatable = false,
  ...props
}) => {
  const Component = isCreatable ? CreatableSelect : Select;

  return (
    <Component
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`react-select-container ${className}`}
      classNamePrefix="react-select"
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 100000000, // higher than modal
        }),
      }}
      {...props}
    />
  );
};

export default CustomSelect;
